export const registerClassesOptions = [
  {
    id: '_ALL_CLASSES',
    label: 'Všechny třídy',
  },
  {
    id: 'PARTY_GROUP',
    label: 'korporace',
  },
  {
    id: 'PERSON',
    label: 'osoba / bytost',
  },
  {
    id: 'DYNASTY',
    label: 'rod / rodina',
  },
  {
    id: 'GEO_OBJECT',
    label: 'geografický objekt',
  },
  {
    id: 'EVENT',
    label: 'událost',
  },
  {
    id: 'ARTWORK',
    label: 'dílo / výtvor',
  },
  {
    id: 'TERM',
    label: 'obecný pojem',
  },
];

const registerSubClassesOptionsIndividual: Record<
  string,
  { id: string; label: string }[]
> = {
  PERSON: [
    {
      id: 'PERSON_INDIVIDUAL',
      label: 'fyzická osoba',
    },
    {
      id: 'FICTIVE_INDIVIDUAL',
      label: 'fiktivní fyzická osoba',
    },
    {
      id: 'PERSON_BEING',
      label: 'bytost',
    },
    {
      id: 'PERSON_ANIMAL',
      label: 'zvíře',
    },
  ],
  DYNASTY: [
    {
      id: 'FAMILY',
      label: 'rod, rodina',
    },
    {
      id: 'FAMILY_BRANCH',
      label: 'větev rodu',
    },
    {
      id: 'FICTIVE_DYNASTY',
      label: 'fiktivní rod, fiktivní rodina',
    },
  ],
  PARTY_GROUP: [
    {
      id: 'REGION',
      label: 'administrativně vymezená území s vlastní správou',
    },
    {
      id: 'PUBLIC_ADMINISTRATION',
      label:
        'orgány, organizační složky a příspěvkové organizace veřejné správy',
    },
    {
      id: 'ORGANIZATION',
      label: 'sdružení organizací',
    },
    {
      id: 'ARMY',
      label: 'vojenské a bezpečnostní jednotky',
    },
    {
      id: 'COMPANY',
      label: 'organizace založené za účelem podnikání',
    },
    {
      id: 'POLITICAL_PARTY',
      label: 'politické organizace',
    },
    {
      id: 'CHURCH',
      label: 'náboženské organizace a instituce',
    },
    {
      id: 'HEALTH_AND_EDU',
      label:
        'kulturní, výchovné, výzkumné a zdravotnické organizace a instituce',
    },
    {
      id: 'CHARITY',
      label: 'nadace a nadační fondy',
    },
    {
      id: 'GUILD',
      label: 'profesní a zájmové organizace',
    },
    {
      id: 'CLUB',
      label: 'spolky, společenské organizace',
    },
  ],
  EVENT: [
    {
      id: 'EVENT_EVENT',
      label: 'organizované akce a události',
    },
    {
      id: 'EVENT_TRADITION',
      label: 'lidové zvyky, významné dny a svátky',
    },
    {
      id: 'EVENT_NATURE',
      label: 'dočasné přírodní jevy',
    },
  ],
  ARTWORK: [
    {
      id: 'ARTWORK_ARTWORK',
      label: 'autorská a umělecká díla',
    },
    {
      id: 'ARTWORK_CHARTER',
      label: 'všeobecně známé dokumenty, smlouvy, zákony, předpisy, normy',
    },
    {
      id: 'ARTWORK_AWARD',
      label: 'vyznamenání, ceny, soutěžní trofeje',
    },
    {
      id: 'ARTWORK_PROD',
      label:
        'výrobky a jejich typová označení, obchodní značky, odrůdy, plemena vytvořená člověkem',
    },
    {
      id: 'ARTWORK_GAME',
      label: 'názvy společenských, dětských her',
    },
    {
      id: 'ARTWORK_PROJ',
      label:
        'programy, projekty, granty, rozvojové plány, kampaně, nemají-li charakter korporace',
    },
    {
      id: 'ARTWORK_CONSTR',
      label:
        'stavby, trasy, zásahy do přírodních útvarů s vlastním jménem nebo jinou identifikací',
    },
  ],
  GEO: [
    {
      id: 'GEO_UNIT',
      label: 'administrativně či jinak lidmi vymezená území',
    },
    {
      id: 'GEO_NATURE_RES',
      label: 'administrativně vymezené části přírody',
    },
    {
      id: 'GEO_ADMIN_UNIT',
      label: 'další vymezené lokality, oblasti a zóny',
    },
    {
      id: 'GEO_SEA_FORMATION',
      label: 'geomorfologické útvary na dně moře',
    },
    {
      id: 'GEO_FORMATION',
      label: 'geomorfologické útvary na zemském povrchu',
    },
    {
      id: 'GEO_WATERS',
      label: 'vodstvo a vodní plocha, vodní tok',
    },
    {
      id: 'GEO_SHAPES',
      label: 'pojmenované útvary',
    },
    {
      id: 'GEO_CLIMATIC_PHEN',
      label: 'pojmenované trvalé klimatické jevy',
    },
    {
      id: 'GEO_SPACE',
      label: 'vesmír a jeho části',
    },
  ],
  TERM: [
    {
      id: 'TERM_TAXONOMY',
      label: 'archivní taxonomická kategorie',
    },
    {
      id: 'TERM_GENERAL',
      label: 'netaxonomické obecné pojmy',
    },
  ],
};

export const registerSubClassesOptions: Record<
  string,
  { id: string; label: string }[]
> = {
  ...registerSubClassesOptionsIndividual,
  _ALL_CLASSES: Object.keys(registerSubClassesOptionsIndividual)
    .map((key) => registerSubClassesOptionsIndividual[key])
    .flat(),
};
